export const formDefaultValues = {
    defaultValues: {
        userId: '',
        userName: '',
        jobTitle: '',
        email: '',
        phone: '',
        comments: '',
        impactedUserFirstName: '',
        impactedUserMiddleInit: '',
        impactedUserLastName: '',
        impactedUserJobTitle: '',
        impactedUserEmail: '',
        impactedSupplierNumber: '',
        impactedSupplierName: '',
        jdsnAppSelection: '',
        partNumber: '',
        purchaseOrder: '',
        ediR2PartNumber: '',
        ediR2PurchaseOrder: '',
        ediR2PlantCode: '',
        ediR2SupplierNumber: '',
        ediR2Document: '',
        supplierNumber: '',
        supplierName: '',
        appUrl: '',
        files: [],
        customOption: ''
    }
};
